import { Injectable } from '@angular/core'
import { AuthService, User } from '@spartacus/core'
import { Observable, of, Subject, BehaviorSubject, combineLatest } from 'rxjs'
import { switchMap, map, share } from 'rxjs/operators'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import { CommonService } from '../../../../shared/services/common.service'
// import {  }

@Injectable({
  providedIn: 'root',
})
export class CheckoutService {
  public inOrderFlowOnly = new BehaviorSubject(false)
  getCartServerResponse = new BehaviorSubject({})
  getCartIdResponse = new BehaviorSubject('')
  getCartReviewOrderResponse = new BehaviorSubject({})
  orderSubmittedStatus = new BehaviorSubject(false)

  public getOrderId = new BehaviorSubject(null)
  recieveOrderId = this.getOrderId.asObservable()
  public getOrderEmail = new BehaviorSubject(null)
  recieveOrderEmail = this.getOrderEmail.asObservable()

  customerData
  user$: Observable<User>
  userId
  activeCart: any
  cartId: any
  shipingInstrctnDefault: any = {
    code: '',
    name: '',
    selected: false,
  }

  public shippingDetailData = new BehaviorSubject('')
  public endUserIndustryData = new BehaviorSubject('')
  public shipmentMethodData = new BehaviorSubject('')
  public carrierdData = new BehaviorSubject('')
  public iNCOTermsData = new BehaviorSubject('')
  public freightTermsData = new BehaviorSubject('')
  public freightTermsAccNoData = new BehaviorSubject('')

  public onorderAckEmailData = new BehaviorSubject('')
  public oninvoiceEmailData = new BehaviorSubject('')
  public onshipNotificationEmailData = new BehaviorSubject('')
  public reasonForCsrReviewData = new BehaviorSubject('')

  public shipingInstrctnData = new BehaviorSubject('')
  recieveShipDetail = this.shipingInstrctnData.asObservable()

  public shipingMarksData = new BehaviorSubject('')
  recieveShipMarksDetail = this.shipingMarksData.asObservable()

  public shipingInstructionsData = new BehaviorSubject('')
  public doOrderReviewData = new BehaviorSubject('')
  public reviewConditionData = new BehaviorSubject(false)
  public onPurchaseOrderReqData = new BehaviorSubject('')
  getPurchaseOrderReqData = this.onPurchaseOrderReqData.asObservable()

  public billToAddressData = new BehaviorSubject(null)
  public deliveryAddressData = new BehaviorSubject(null)
  public endCustomerAddressData = new BehaviorSubject(null)

  getdeliveryAddData = this.deliveryAddressData.asObservable()
  getEndCustomerAddData = this.endCustomerAddressData.asObservable()

  public sanctionCheckData1 = new BehaviorSubject('')
  public restrictedCountryCheckData2 = new BehaviorSubject('')
  public restrictedPartListData3 = new BehaviorSubject('')
  public warningFlagsData4 = new BehaviorSubject('')
  public isNuclearData5 = new BehaviorSubject('')
  public hasRestrictedUseData6 = new BehaviorSubject('')
  public requiresExportLicenseData7 = new BehaviorSubject('')
  public customerReviewCheckData8 = new BehaviorSubject('')

  public getSepcsialInst = new BehaviorSubject(null)
  receiveSpcailInsOthers = this.getSepcsialInst.asObservable()

  public customerDataForm = new BehaviorSubject(null)
  receivecustomerDataForm = this.customerDataForm.asObservable()

  public shipmentDataForm = new BehaviorSubject(null)
  receiveshipmentDataForm = this.shipmentDataForm.asObservable()

  public carrierDataForm = new BehaviorSubject(null)
  receivecarrierDataForm = this.carrierDataForm.asObservable()

  public orderAckDataForm = new BehaviorSubject(null)
  receiveorderAckDataForm = this.orderAckDataForm.asObservable()

  public addressObjData = new BehaviorSubject('')

  public specialInstructionObj = new BehaviorSubject('')

  retainEndUserIndustry = new BehaviorSubject({})

  orderpreferences = new BehaviorSubject({})
  podetails = new BehaviorSubject({})
  shippinginstructions = new BehaviorSubject({})

  public specialdocSIData = new BehaviorSubject(
    this.constructDefaultObj('Special Documentation', 'Special Documentation')
  )
  public finaltestSIData = new BehaviorSubject(
    this.constructDefaultObj('Final Test Report', 'Final Test Report')
  )
  public valvesdimenSIData = new BehaviorSubject(
    this.constructDefaultObj(
      'Valves Dimensional Drawing Acceptance',
      'Valves Dimensional Drawing Acceptance'
    )
  )
  public iNstructionSIData = new BehaviorSubject(
    this.constructDefaultObj('Instruction Manuals', 'Instruction Manuals')
  )
  public cMTRSSIData = new BehaviorSubject(
    this.constructDefaultObj('CMTRs', 'CMTRs')
  )
  public inspectionTestSIData = new BehaviorSubject(
    this.constructDefaultObj(
      'Inspection & Testing Requirements',
      'Inspection & Testing Requirements'
    )
  )
  public othersSIData = new BehaviorSubject(
    this.constructDefaultObj('Others', 'Others')
  )
  public witnessInspctnData = new BehaviorSubject(
    this.constructDefaultObj('Witness Inspection', 'Witness Inspection')
  )
  public bankGuaranteeData = new BehaviorSubject(
    this.constructDefaultObj('Bank Guarantee', 'Bank Guarantee')
  )
  public certificateOriginData = new BehaviorSubject(
    this.constructDefaultObj('Certificate of Origin', 'Certificate of Origin')
  )
  public cooStampData = new BehaviorSubject(
    this.constructDefaultObj(
      'COO w/Chamber of Comm Stamp',
      'COO w/Chamber of Comm Stamp'
    )
  )
  public certificateConformanceData = new BehaviorSubject(
    this.constructDefaultObj(
      'Certificate of Conformance',
      'Certificate of Conformance'
    )
  )
  public certificateManufactureData = new BehaviorSubject(
    this.constructDefaultObj(
      'Certificate of Manufacture',
      'Certificate of Manufacture'
    )
  )
  public warrantyCertificateData = new BehaviorSubject(
    this.constructDefaultObj('Warranty Certificate', 'Warranty Certificate')
  )
  public cartReviewRes = new BehaviorSubject('')
  recievecartReviewRes = this.cartReviewRes.asObservable()

  public getErrFlag = new BehaviorSubject('')
  recieveErrFlag = this.getErrFlag.asObservable()

  public getCountFiles = new BehaviorSubject(0)
  recieveCount = this.getCountFiles.asObservable()

  public checkboxData = new BehaviorSubject(null)
  reciveCheckboxData = this.checkboxData.asObservable()

  public cartAttachments = new BehaviorSubject(null)
  reciveCartAttachments = this.cartAttachments.asObservable()

  public sendCheckNuclear = new BehaviorSubject('')
  recieveNuclear = this.sendCheckNuclear.asObservable()
  NuclearCheck: any
  cartCode: any
  cartEmail: any
  shipCode: any
  shipMarks: any
  cartRes: any
  ErrFlag: any
  spcailOthers: any
  storeOrderId = new BehaviorSubject('')
  storeOrderEmail = new BehaviorSubject('')
  storePlaceOrderStatus = new BehaviorSubject(false)

  constructor(
    public commonService: CommonService,
    private auth: AuthService,

    protected activeCartService: ActiveCartFacade,
    private userAccountFacade: UserAccountFacade
  ) {
       this.auth.isUserLoggedIn().subscribe((success) => {
         if (success) {
           this.activeCartService.getActiveCartId().subscribe((success) => {            
               this.cartId = success
           })
         }
       })
  }

  constructDefaultObj(defaultName, defaultCode) {
    return { code: defaultCode, name: defaultName, selected: 'false' }
  }
  //BEHAVIOUR SUBJECT METHOD
  //adding code here
  sendCartAttachments(attachments) {
    this.cartAttachments.next(attachments)
  }
  sendErrorFlag(valid) {
    this.getErrFlag.next(valid)
  }
  sendCountFiles(count) {
    this.getCountFiles.next(count)
  }
  getErrorFlag() {
    return this.ErrFlag
  }
  sendOrderId(valid) {
    this.cartCode = valid
    this.getOrderId.next(valid)
  }
  sendNuclear(valid: any) {
    this.sendCheckNuclear.next(valid)
  }

  specailInsOthers(valid: any) {
    this.getSepcsialInst.next(valid)
  }

  getspecailInsOthers(valid: any) {
    return this.spcailOthers
  }

  getNuclearCheck() {
    return this.NuclearCheck
  }
  sendCartReview(valid: any) {
    this.cartReviewRes.next(valid)
  }
  getCartReview() {
    return this.cartRes
  }
  sendOrderEmail(valid) {
    this.cartEmail = valid
    this.getOrderEmail.next(valid)
  }
  sendShipDetails(valid) {
    this.shipCode = valid
    this.shipingInstrctnData.next(valid)
  }
  sendShipMarksDetails(valid) {
    this.shipMarks = valid
    this.shipingMarksData.next(valid)
  }

  getShipDetails() {
    return this.shipingInstrctnData
  }

  getCartCode() {
    return this.cartCode
  }
  getCartEmail() {
    return this.cartEmail
  }
  getShpCodes() {
    return this.shipCode
  }

  getCart(cartId) {
    const urlparams = ['users', 'current', 'vscart', cartId]
    const apiUrl = this.commonService.constructUrl(urlparams)
    return this.commonService.getData(apiUrl).pipe(share())
  }

  getComplianceQues(cartID) {
    // const checkoutCartid = sessionStorage.getItem("cartId-current")
    const urlparams = ['vsExportCompliance', cartID, 'questions']
    const apiQuestionUrl = this.commonService.constructUrl(urlparams)
    return this.commonService.getData(apiQuestionUrl)
  }

  getComplianceQuesLegal() {
    const urlparams = ['users', 'current', 'vscart', 'legalEntity']
    const apiUrl = this.commonService.constructUrl(urlparams)
    return this.commonService.getData(apiUrl)
  }

  getIncoTermsCustomer(cartId) {
    const urlparams = ['users', 'current', 'vscart', cartId, 'getIncoTerms']
    const apiUrl = this.commonService.constructUrl(urlparams)
    return this.commonService.getData(apiUrl)
  }

  getShipmentMethod(cartId) {
    const urlparams = [
      'users',
      'current',
      'vscart',
      cartId,
      'getShipmentMethodData',
    ]
    const apiUrl = this.commonService.constructUrl(urlparams)
    return this.commonService.getData(apiUrl)
  }

  getSpecialInstructionData(cartId) {
    const urlparams = [
      'users',
      'current',
      'vscart',
      cartId,
      'getSpecialInstructionData',
    ]
    const apiUrl = this.commonService.constructUrl(urlparams)
    return this.commonService.getData(apiUrl)
  }

  sendCustomerDataForm(valid: boolean) {
    this.customerDataForm.next(valid)
  }

  sendShipmentdataForm(valid: boolean) {
    this.shipmentDataForm.next(valid)
  }

  sendCarrierdataForm(valid: boolean) {
    this.carrierDataForm.next(valid)
  }

  sendOrderAckdataForm(valid: boolean) {
    this.orderAckDataForm.next(valid)
  }

  sendCheckboxFlag(checked: boolean) {
    this.checkboxData.next(checked)
  }

  getCarrierData(cartId) {
    const urlparams = ['users', 'current', 'vscart', cartId, 'getCarrierData']
    const apiUrl = this.commonService.constructUrl(urlparams)
    return this.commonService.getData(apiUrl)
  }

  fetchFreightTerms(selectedINCOTerm: any, cartId) {
    const urlparams = [
      'users',
      'current',
      //503195990,
      'vscart',
      cartId,
      selectedINCOTerm,
      'getModeForIncoTerm',
    ]

    const apiUrl = this.commonService.constructUrl(urlparams)
    return this.commonService.getData(apiUrl)
  }

  getLoggedInUserData() {
    this.user$ = this.auth.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          return this.userAccountFacade.get()
        } else {
          return of(undefined)
        }
      })
    )
  }

  getDetailsForOrderNotifications(cartId?) {
    const urlparams = [
      'users',
      'current',
      'vscart',
      cartId,
      'getDetailsForOrderNotifications',
    ]
    const apiUrl = this.commonService.constructUrl(urlparams)
    return this.commonService.getData(apiUrl)
  }

  getEndUserIndustry(cartId) {
    const urlparams = ['users', 'current', 'vscart', cartId, 'endUserIndustry']
    const apiUrl = this.commonService.constructUrl(urlparams)
    return this.commonService.getData(apiUrl)
  }

  fetchSpecialInstructionData(cartId) {
    const urlparams = [
      'users',
      'current',
      'vscart',
      cartId,
      'getSpecialInstructionData',
    ]
    const apiUrl = this.commonService.constructUrl(urlparams)
    return this.commonService.getData(apiUrl)
  }

  getCartReviewOrder(cartId) {
    const urlparams = ['users', 'current', 'vscart', cartId]
    const apiUrl = this.commonService.constructUrl(urlparams)
    return this.commonService.getData(apiUrl).pipe(share())
  }

  downloadOrderPdf(userId, id) {
    const params = ['users', userId, 'vscart', id, 'downloadCartReviewPdf']
    const apiUrl = this.commonService.constructUrl(params)
    return this.commonService.getData_PDF(apiUrl)
  }

  downloadOrderCnfPdf(userType, id) {
    const params = ['users', userType, 'downloadOrderPdf', id]
    const apiUrl = this.commonService.constructUrl(params)
    return this.commonService.getData_PDF(apiUrl)
  }
  getShiptoAndEndUser(userType, id, unitId) {
    const params = ['users', 'current', 'vscart', id, 'getShiptoAndEndUser']
    const apiUrl = this.commonService.constructUrl(params)
    let apiParams = {
      soldToUnitId: unitId,
    }
    return this.commonService.getData(apiUrl, apiParams)
  }
}
